import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import SearchSelect from "views/lib/components/SearchSelect";
import {
  getZoneTemplates
} from "actions/zone/actions";

const SelectFromTemplateZone = ({
                                  loading,
                                  getZoneTemplates,
                                  zoneTemplates,
                                  onSubmit,
                                  onCancel
                                }) => {
  const [template, setTemplate] = useState(null);

  const handleSubmit = () => {
    if (!template) return false;

    const currentTemplateData = zoneTemplates.find(item => item.id === template.value);
    if (!currentTemplateData) return false;

    onSubmit(currentTemplateData);
  };

  useEffect(() => {
    getZoneTemplates();
  }, [getZoneTemplates]);

  return (
    <div>
      <div className="form-group">
        <label>Select Template</label>
        <SearchSelect
          className="search-select"
          isLoading={loading}
          isSearchable={true}
          isClearable={false}
          onChange={setTemplate}
          value={template}
          options={zoneTemplates.map(item => ({
            label: item.name,
            value: item.id,
          }))}
        />
      </div>
      <div className="text-right">
        <button
          className="btn btn-danger mr-2"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          className="btn btn-success"
          disabled={!template}
          onClick={handleSubmit}
        >
          Add
        </button>
      </div>
    </div>
  );
};

SelectFromTemplateZone.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  loading: state.zone.loading,
  zoneTemplates: state.zone.zoneTemplates,
});

const mapStateToDispatch = dispatch => ({
  getZoneTemplates: bindActionCreators(getZoneTemplates, dispatch)
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(SelectFromTemplateZone);



// WEBPACK FOOTER //
// ./src/views/pages/zoning/select-from-template-zone.js